<template>
  <div
    class="part-area"
    :class="classes"
  >
    <v-card
      v-if="partNo"
      class="part-num part-num--primary"
    >{{partNo}}
    </v-card>
    <div class="part-area__image" @click.stop="$emit('on-click-preview')" ref="imageAreaElement">
      <v-img :src="questionImage" max-height="200px" :max-width="maxWidth" position="top" class="mx-auto"/>
    </div>
    <v-delete-btn class="delete-btn" v-if="showDeleteBtn" @click="$emit('on-click-remove', partNo-1)"/>
    <div class="part-area__detail">
      <v-container dense class="py-0 my-0">
        <v-row>
          <v-part-item v-if="$app.isDevMode" title="コンテンツコード" :content="contentCode"/>
          <v-part-item title="単元内容" :content="chapterName"/>
          <v-part-item title="教材" :content="material"/>
          <v-part-item title="ページ" :content="pageRange" v-if="pageRange" />
          <v-part-item title="競技" :content="athleticEvent" v-if="athleticEvent" />
          <v-part-item title="問題数" :content="questionCnt+'問'"/>
          <v-part-item title="観点" :content="viewPoint"/>
          <v-part-item title="使用回数" :content="'使用回数：'+usedTime+'回'"/>
          <v-part-item title="再生時間" v-if="!!listeningTime" :content="'再生時間：'+listeningTime+'秒'"/>
          <div class="star--container" @click="$emit('on-click-favorite', contentCode)">
            <div v-if="isFavorite" class="star--active"></div>
            <div v-else class="star--unactive"></div>
          </div>
        </v-row>
      </v-container>
    </div>
    <slot name="options"/>
  </div>
</template>

<script>
import VPartItem from '@/components/atoms/PartItem'
import VDeleteBtn from '@/components/atoms/DeleteBtn'

export default {
  components: {
    VPartItem,
    VDeleteBtn
  },

  data: () => ({
    imageSize: null
  }),

  mounted() {
    this.getImageSize(this.questionImage)
  },

  watch: {
    questionImage() {
      this.getImageSize(this.questionImage)
    },
  },

  props: {
    contentCode: {
      type: String,
      require: true,
    },
    partNo: {
      type: Number,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'gray'
    },
    chapterName: {
      type: String,
      require: true,
    },
    questionCnt: {
      type: Number,
      require: true,
    },
    questionImage: {
      type: String,
      require: true,
    },
    answerImage: {
      type: String,
      require: true,
    },
    pageRange: {
      type: String,
      require: true,
    },
    material: {
      type: String,
      require: true,
    },
    athleticEvent: {
      type: String,
    },
    questionType: {
      type: String,
      require: true,
    },
    difficulty: {
      type: String,
      require: true,
    },
    viewPoint: {
      type: String,
      require: true,
    },
    usedTime: {
      type: Number,
      require: true,
    },
    active: {
      type: Boolean,
      default: false
    },
    alert: {
      type: Boolean,
      default: false
    },
    listeningTime: {
      type: String,
      default: ''
    },
    isFavorite: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    classes() {
      return {
        'part-area--active' : this.active,
        'part-area--alert' : this.alert,
      }
    },
    maxWidth() {
      let size = this.imageSize
      if (size) {
        let width = size.width / 2
        if (width < this.$refs.imageAreaElement.clientWidth) {
          // 横幅が余っていても原寸の半分以上には拡大しないようにする
          return `${width}px`
        }
      }
      return "auto"
    },
  },

  methods: {
    getImageSize (src) {
      if (src) {
        let img = new Image()
        img.onload = () => {
          this.imageSize = {width: img.width, height: img.height}
        }
        img.src = src
      } else {
        this.imageSize = null
      }
    }
  },
}
</script>

<style lang="stylus" scoped>

tbody
  font-size 11px

.part-area
  margin-bottom 10px
  box-sizing border-box
  box-shadow 0px 0px 4px #5c5858
  border-radius 5px
  background-color white
  position relative
  transition: box-shadow .3s, transform 0.3s;

  &__image
    cursor pointer
    padding: 5px 15px;
    border-bottom #e9e9e9 1px solid

  &__detail
    padding 10px
    font-size 10px
    border-bottom #e9e9e9 1px solid

  &__fotter
    padding 10px
    position relative
    height 50px

  &--active
    box-shadow 0px 0px 4px 2px #329d22

  &--alert
    box-shadow 0px 0px 4px 2px #fa1f38

.delete-btn
  position absolute
  top -8px
  right -8px

.part-num
  border: 2px solid #ffffff;
  color: white;
  font-weight: bold;
  width 35px
  height 35px
  font-size 14px
  text-align center
  line-height 35px
  position absolute
  top -12px
  left -12px
  z-index 1

  &--primary
    background-color #468ca3

  &--gray
    background-color #53708d

.star--container
  cursor pointer
  margin-top 7px
  margin-left auto
  filter drop-shadow(0px 1px 1px #DCDCDC)

.star--active
  transition-duration 200ms
  position relative
  border-bottom 8px solid #FFEB3B
  border-right 12px solid transparent
  border-left 12px solid transparent
  transform rotate(-37deg)

.star--active::before
  transition-duration 200ms
  content ""
  position absolute
  left -12px
  border-bottom 8px solid #FFEB3B
  border-right 12px solid transparent
  border-left 12px solid transparent
  transform rotate(-71.5deg)

.star--active::after
  transition-duration 200ms
  content ""
  position absolute
  left -12px
  border-bottom 8px solid #FFEB3B
  border-right 12px solid transparent
  border-left 12px solid transparent
  transform rotate(71.5deg)

.star--unactive
  transition-duration 200ms
  position relative
  border-bottom 8px solid #e4e4e4
  border-right 12px solid transparent
  border-left 12px solid transparent
  transform rotate(-37deg)

.star--unactive::before
  transition-duration 200ms
  content ""
  position absolute
  left -12px
  border-bottom 8px solid #e4e4e4
  border-right 12px solid transparent
  border-left 12px solid transparent
  transform rotate(-71.5deg)

.star--unactive::after
  transition-duration 200ms
  content ""
  position absolute
  left -12px
  border-bottom 8px solid #e4e4e4
  border-right 12px solid transparent
  border-left 12px solid transparent
  transform rotate(71.5deg)
</style>
